import {
  ADMINDASHBOARD_DATA_GET,
  ADMINDASHBOARD_DATA_SUCCESS
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  adminDashboardDetails: "",
}

const adminDashboardGet = (state = initialState, action) => {
  switch (action.type) {
    case ADMINDASHBOARD_DATA_GET:
      state = {
        ...state,
        loading: true,
      }
      break
    case ADMINDASHBOARD_DATA_SUCCESS:
      state = {
        ...state,
        loading: false,
        isUserLogout: false,
        adminDashboardDetails:action.payload,
      }
      break

    default:
      state = { ...state }
      break
  }
  return state
}

export default adminDashboardGet


